import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.34415 11.3806C0.885282 10.5873 0.885282 9.61268 1.34415 8.81944L4.4851 3.38058C4.94398 2.58733 5.78702 2.10001 6.70476 2.10001H12.9831C13.8973 2.10001 14.7439 2.58733 15.2028 3.38058L18.3402 8.81944C18.799 9.61268 18.799 10.5873 18.3402 11.3806L15.1992 16.8194C14.7403 17.6127 13.8973 18.1 12.9795 18.1H6.7012C5.78702 18.1 4.94042 17.6127 4.48155 16.8194L1.34415 11.3806ZM9.84215 5.54687C9.36905 5.54687 8.98844 5.92749 8.98844 6.40058V10.3846C8.98844 10.8577 9.36905 11.2383 9.84215 11.2383C10.3153 11.2383 10.6959 10.8577 10.6959 10.3846V6.40058C10.6959 5.92749 10.3153 5.54687 9.84215 5.54687ZM10.9804 13.5149C10.9804 13.213 10.8605 12.9234 10.647 12.71C10.4336 12.4965 10.144 12.3766 9.84215 12.3766C9.54026 12.3766 9.25073 12.4965 9.03726 12.71C8.82379 12.9234 8.70387 13.213 8.70387 13.5149C8.70387 13.8167 8.82379 14.1063 9.03726 14.3197C9.25073 14.5332 9.54026 14.6531 9.84215 14.6531C10.144 14.6531 10.4336 14.5332 10.647 14.3197C10.8605 14.1063 10.9804 13.8167 10.9804 13.5149Z",
		fill: "#0D2976"
	})
});
export default SvgError;
